// ISO 3166-1 alpha-2 country codes and names
export const COUNTRIES = [
  { code: "TR", name: "Turkey" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "CH", name: "Switzerland" },
  { code: "AT", name: "Austria" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PL", name: "Poland" },
  { code: "CZ", name: "Czech Republic" },
  { code: "GR", name: "Greece" },
  { code: "PT", name: "Portugal" },
  { code: "IE", name: "Ireland" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "JP", name: "Japan" },
  { code: "CN", name: "China" },
  { code: "IN", name: "India" },
  { code: "BR", name: "Brazil" },
  { code: "MX", name: "Mexico" },
  { code: "Other", name: "Other" },
];

export const getCountryName = (code) => {
  const country = COUNTRIES.find((c) => c.code === code);
  return country ? country.name : code;
};

export const getCountryCode = (name) => {
  const country = COUNTRIES.find((c) => c.name === name);
  return country ? country.code : name;
};

export function getCountryFlagEmoji(code) {
  if (!code || code === "Other") return "🌍";
  const upper = String(code).toUpperCase();
  if (upper.length !== 2) return "🌍";
  const points = [...upper].map((char) => 0x1f1e6 - 65 + char.charCodeAt(0));
  return String.fromCodePoint(...points);
}
